import { get } from 'lodash';
import { Owner } from '../polymer/Owner.model';
import { HoldingFormData } from '../polymer/HoldingFormData.model';

export class ApplicationStep5 {
  outgoing_owner_represented?: Owner;
  input_verified: boolean;
  holding_form_values: HoldingFormData;

  constructor(initial?: any) {
    this.outgoing_owner_represented = get(initial, 'outgoing_owner_represented', undefined);
    this.input_verified = get(initial, 'input_verified', false);
    this.holding_form_values = get(initial, 'holding_form_values', new HoldingFormData());
  }
}
